import { useState } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { Button, Text } from '@homebotapp/hb-react-component-catalog'
import { HOME_SEARCH_LISTING_DETAILS } from '../../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'

export const MSG = defineMessages({
  more: {
    id: 'HomeSearch.listingDetails.description.showMore',
    defaultMessage: 'show more'
  }
})

export interface ReadMoreProps {
  text: string
  truncateCount: number
}

export const ReadMore = ({ text, truncateCount }: ReadMoreProps) => {
  const intl = useIntl()
  const [truncate, setTruncate] = useState(true)
  const truncatedTxt = text?.length > truncateCount ? `${text.substring(0, truncateCount)}... ` : ''

  return (
    <Text data-qa='read-more'>
      {truncatedTxt && truncate ? (
        <>
          {truncatedTxt}
          <Button
            size='xs'
            variant='link'
            colorScheme='primary'
            onClick={() => setTruncate(!truncate)}
            tracking={{
              guid: 'xacJQdx9kLeM5eReMtJGXs',
              ui_context: HOME_SEARCH_LISTING_DETAILS,
              descriptor: MSG.more.defaultMessage
            }}
          >
            {intl.formatMessage(MSG.more)}
          </Button>
        </>
      ) : (
        text
      )}
    </Text>
  )
}
